<div class="main-wrapper">
	<div class="icon-wrapper" *ngIf="iconClass"><i [attr.class]="iconClass"></i></div>
	<div class="primary-text-wrapper" title="{{primaryText}}">{{primaryText}}</div>
	<div class="secondary-text-wrapper" title="{{secondaryText}}">{{secondaryText}}</div>
</div>
